/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Vue, Component, Model, Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ContractItem, openContract } from '@/ContractConfig';
import { Popup } from 'vant';
import ProductCommodity from '@/shared/commodity';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const style = require('./index.module.scss');

const CardBindStore = namespace('cardBind');

@Component
export default class ContractList extends Vue {
  @CardBindStore.State contractList!: ContractItem[];

  @CardBindStore.Action getContractList!: (payload: {
    commodityId: string;
    capitalCode?: string;
  }) => Promise<void>;

  @Model('change', {
    type: Boolean,
  })
  readonly visible!: boolean;

  @Prop(String) readonly entryFrom!: string;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode?: string;

  private render() {
    return (
      <Popup
        position="bottom"
        v-model={this.visible}
        closeOnClickOverlay={false}
        onClick-overlay={this.onCancel.bind(this)}
      >
        <div class={style.contractList}>
          <div class={style.actionList}>
            {this.contractList.map((item) => (
              <div
                key={item.name}
                class={[style.actionItem, 'van-hairline--bottom']}
                onClick={this.onSelect.bind(this, item)}
              >
                {item.name}
              </div>
            ))}
          </div>
          <div class={style.cancelButton} onClick={this.onCancel.bind(this)}>
            取消
          </div>
        </div>
      </Popup>
    );
  }

  private async onSelect(item: ContractItem) {
    if (this.contractList.length <= 1) {
      this.$emit('change', false);
    }

    this.$ubtPageButton('OpenBindCardContract', 'entryFrom', this.entryFrom);

    // 为富民银行做的一点特殊改造。。
    if (this.commodityId === ProductCommodity.FUMINBANK) {
      await this.getContractList({
        commodityId: this.commodityId,
        capitalCode: this.capitalCode,
      });
      const [contractItem] = this.contractList.filter((newItem) => newItem.name === item.name);
      openContract(contractItem);
      return;
    }

    openContract(item);
  }

  private onCancel() {
    this.$emit('change', false);
    this.$ubtPageButton('HideContractList', 'entryFrom', this.entryFrom);
  }
}
